import { FunctionComponent } from 'react'
import { Role } from '@/types/Role'
import ParentHome from './parentHome'
import StaffHome from './staffHome'
import { RequireAuth } from '@/modules/routes/requireAuth'
import { useAuth } from '@/modules/context/AuthContext'
import CALDHome from './CALDHome'
import TrusteeHome from './TrusteeHome'

interface HomeProps {
    backendVersion: string
    frontendVersion: string
}

const Home: FunctionComponent<HomeProps> = ({ backendVersion, frontendVersion }: HomeProps) => {
    const { user } = useAuth()

    return (
        <RequireAuth roles={[Role.parent, Role.staff, Role.trustee, Role.cald]}>
            <>
                {user && user.role === Role.parent && (
                    <ParentHome backendVersion={backendVersion} frontendVersion={frontendVersion} />
                )}
                {user && user.role === Role.staff && (
                    <StaffHome backendVersion={backendVersion} frontendVersion={frontendVersion} />
                )}
                {user && user.role === Role.cald && (
                    <CALDHome backendVersion={backendVersion} frontendVersion={frontendVersion} />
                )}
                {user && user.role === Role.trustee && (
                    <TrusteeHome backendVersion={backendVersion} frontendVersion={frontendVersion} />
                )}
            </>
        </RequireAuth>
    )
}

export default Home
